var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuth0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5432,
    cy: 23.5432,
    r: 23.5432,
    fill: "url(#paint0_radial_10_1350)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6663 34.8405L28.5629 25.4161L36.6893 19.5909C38.6889 25.6371 36.6893 31.2413 31.6663 34.8405ZM36.6893 19.5909L33.5859 10.1665H23.5398L26.6273 19.5909H36.6893ZM23.5398 10.1665H13.4938L10.4064 19.5909H20.4524L23.5398 10.1665ZM10.3904 19.5909C8.40676 25.6371 10.3904 31.2413 15.4134 34.8405L18.5008 25.4161L10.3904 19.5909ZM15.4134 34.8405L23.5398 40.6657L31.6663 34.8405L23.5398 29.0154L15.4134 34.8405Z",
    fill: "#EB5424"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_10_1350",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.9821 10.969) rotate(52.6646) scale(92.1962)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#595959"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuth0);
export default __webpack_public_path__ + "static/media/auth0.2ea2fadfbc213a84937397d3cdee1d14.svg";
export { ForwardRef as ReactComponent };